import { impersonateAxiosRequestConfig as axiosRequestConfig } from '@apis/common';
import * as t from 'io-ts';
import { tyrann } from 'tyrann-io';

export const impersonateApis = tyrann(
  {
    '/impersonate/{id}/': {
      get: {
        path: t.type({
          id: t.number,
        }),
        response: {
          200: t.type({
            impersonate_id: t.number,
            original_user_id: t.number,
          }),
          403: t.type({
            code: t.string,
            message: t.string,
          }),
        },
      },
    },
    '/unimpersonate/': {
      get: {
        response: {
          200: t.type({}),
          403: t.type({
            code: t.string,
            message: t.string,
          }),
        },
      },
    },
  },
  {
    axiosRequestConfig,
  },
);
